module.exports = "<svg viewBox=\"0 0 50 50\"><polyline points=\"4.33,19.64 9.7,27.69 15.95,20.54 \"></polyline><path d=\"M9.71,27.69C8.36,16.81,16.68,8.38,26.06,8.03c9.37-0.35,17.25,6.97,17.6,16.35 c0.35,9.38-6.97,17.26-16.35,17.6\"></path><polyline points=\"26.68,16.06 26.68,25.89 35.62,25.89 \"></polyline></svg>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphcool-styles/icons/stroke/history.svg
// module id = 499
// module chunks = 0 1